var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1739 18.3587L13.4183 9.36811C13.0859 9.18188 12.7046 9.10135 12.3253 9.13724C11.946 9.17314 11.5866 9.32374 11.295 9.56901C11.0034 9.81428 10.7934 10.1426 10.6931 10.5101C10.5928 10.8777 10.6068 11.2671 10.7333 11.6265L13.603 19.99L10.7333 28.3759C10.6333 28.6586 10.6026 28.9612 10.6437 29.2582C10.6848 29.5553 10.7965 29.8381 10.9695 30.0831C11.1426 30.328 11.3718 30.5278 11.638 30.6658C11.9043 30.8039 12.1997 30.876 12.4996 30.8762C12.8218 30.8756 13.1384 30.7923 13.4193 30.6344L13.4277 30.6287L29.1777 21.6222C29.4665 21.4587 29.7067 21.2215 29.8738 20.9349C30.041 20.6482 30.1291 20.3223 30.1291 19.9905C30.1291 19.6586 30.041 19.3327 29.8738 19.0461C29.7067 18.7594 29.4665 18.5222 29.1777 18.3587H29.1739ZM13.1783 28.179L15.5933 21.1262H20.7496C21.0479 21.1262 21.3341 21.0077 21.5451 20.7967C21.756 20.5858 21.8746 20.2996 21.8746 20.0012C21.8746 19.7029 21.756 19.4167 21.5451 19.2057C21.3341 18.9948 21.0479 18.8762 20.7496 18.8762H15.5999L13.1793 11.8225L27.4939 19.9909L13.1783 28.179Z",
    fill: "#54595E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send_icon.879c25158cfe779ac494c853961e41d7.svg";
export { ForwardRef as ReactComponent };